import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NotesDataServiceProvider {
	notes: BehaviorSubject<any> = new BehaviorSubject(false);
	notesUpdateEvent: Subject<any> = new Subject();

	constructor(private http: HttpClient) {}

	get notesObservable(): Observable<string> {
		return this.notes.asObservable();
	}

	get shouldNotesBeUpdatedObservable(): Observable<any> {
		return this.notesUpdateEvent.asObservable();
	}

	emitNotes(notes: string): void {
		this.notes.next(notes);
	}

	emitNotesUpdateEvent(value: string): void {
		this.notesUpdateEvent.next(value);
	}

	saveNotes = (notes, isClient): Observable<any> => {
		const url = isClient
			? '/protected/rest/clients/notes/update'
			: '/protected/rest/job/notes/update';
		return this.http.post(url, notes);
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/notes/notes.data.service.ts